/** 
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');
	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const parser = new DOMParser().parseFromString(text, 'text/html');
				const recommendationContent = parser.querySelector('product-recommendations');
				if (recommendationContent && recommendationContent.innerHTML.trim().length && !this.classList.contains('is-loaded')) {

					const productCards = recommendationContent.querySelectorAll('product-card, [data-product-id]');

					if(productCards.length > 0) {
						this.innerHTML += recommendationContent.innerHTML;
						if (this.parent) {
							this.parent.classList.add('product-recommendations--full');
							
							if (document.body.classList.contains('open-cart')) {
								this.parent.classList.add('active');
							}
						}
						
					}

					

				}

				this.classList.add('product-recommendations--loaded');

				const event = new Event('recommendations-loaded');
				document.dispatchEvent(event);
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
}

customElements.define('product-recommendations', ProductRecommendations);